import React, { useEffect, useRef, useState } from "react";
import { ThemeProvider, Snackbar, Grow, Alert, Button} from '@mui/material';
import { defaultTheme } from 'theme';
import {
  InfoOutlined,
  CloseOutlined
} from '@mui/icons-material';

import { FeedbackModal } from "./FeedbackModal";

const FeedbackToasterModal = () => {
  const [feedbackToasterModal, setFeedbackToasterModal] = useState(false);
  const reminderIntervalRef = useRef(null);
  const sessionStartTimeRef = useRef(Date.now());
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  function SlideTransition(props) {
    return <Grow {...props} direction="down" />;
  }

  useEffect(() => {
    const showFeedbackReminder = () => {
      setFeedbackToasterModal(true);

      setTimeout(() => {
        setFeedbackToasterModal(false);
      }, 45000);
    };

    const timeSinceStart = Date.now() - sessionStartTimeRef.current;
    const initialDelay = Math.max(0, (5 * 60 * 1000) - timeSinceStart);
    
    const initialTimeout = setTimeout(() => {
      showFeedbackReminder();
      reminderIntervalRef.current = setInterval(showFeedbackReminder, 5 * 60 * 1000);
    }, initialDelay);

    return () => {
      clearTimeout(initialTimeout);
      if (reminderIntervalRef.current) {
        clearInterval(reminderIntervalRef.current);
      }
    };
  }, [setFeedbackToasterModal]);

return (
    <div>
    <ThemeProvider theme={defaultTheme}>
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={feedbackToasterModal}
            key={'Help us make this platform better'}
            TransitionComponent={SlideTransition}
            sx={{ zIndex: '99999' }}
        >
            <Alert
                severity="info"
                iconMapping={{
                    info: <InfoOutlined color='info' sx={{ height: '22px', width: '22px' }} />,
                }}
                sx={{
                    padding: '6px 16px',
                    fontSize: '16px',
                    fontWeight: '500',
                    lineHeight: '24px',
                    letterSpacing: '0.15px',
                    borderRadius: '4px',
                    background: 'rgba(229, 246, 253, 1)',
                    color: 'rgba(0, 84, 164, 0.5)',
                    border: 'rgba(1, 67, 97, 1)',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <span style={{ marginRight: '16px' }}>Help us make this platform better</span>
                <Button variant='contained' size='small' sx={{marginRight: '8px'}} onClick={() => {
                    setFeedbackModalOpen(true);
                }}>
                    Provide Feedback
                </Button>
                <CloseOutlined sx={{ cursor: 'pointer', marginBottom: '-8px' }} onClick={() => {
                    setFeedbackToasterModal(false);
                }} />
            </Alert>
        </Snackbar>
    </ThemeProvider>
    <FeedbackModal
            open={feedbackModalOpen}
            onClose={() => {
              setFeedbackModalOpen(false);
              setFeedbackToasterModal(false);
            }}
            title='Please provide feedback'
            onSubmit={() => {
                setFeedbackToasterModal(false);
                setFeedbackModalOpen(false);
            }}
        />
    </div>
);
}

export default FeedbackToasterModal;